import {
  createEditor,
  ParagraphNode,
  TextNode,
} from 'lexical'
import { registerDragonSupport } from '@lexical/dragon'
import { createEmptyHistoryState, registerHistory } from '@lexical/history'
import { mergeRegister } from '@lexical/utils'
import { registerRichText } from '@lexical/rich-text'
import { $getRoot, $getSelection } from 'lexical'
import 'emoji-picker-element'

const LexicalEditor = {
  mounted() {
    const config = {
      namespace: 'ChatEditor',
      editable: true,
      theme: {},
      onError: console.error,
      nodes: [
        ParagraphNode,
        TextNode,
      ],
    }

    const editor = createEditor(config)
    const rootElement = this.el

    editor.setRootElement(rootElement)

    this.el.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.shiftKey === false) {
        editor.update(() => {
          const root = $getRoot();

          this.el.closest('form').dispatchEvent(
            new Event('submit', { bubbles: true, cancelable: true }),
          )
          root.clear()
        })
      }
    })

    this.handleEvent('clear-lexical-editor', () => {
      editor.update(() => {
        const root = $getRoot();

        root.clear()
      })
    })

    mergeRegister(
      registerRichText(editor),
      registerDragonSupport(editor),
      registerHistory(editor, createEmptyHistoryState(), 300),
    )

    editor.registerTextContentListener((textContent) => {
      document.getElementById('hidden-chat-message').value = textContent
    })

    // emoji picker
    const emojiPicker = document.getElementById('emoji-picker')

    emojiPicker?.addEventListener('emoji-click', (event) => {
      const emoji = event.detail.unicode

      this.el.focus();

      editor.update(() => {
        const selection = $getSelection()

        if (selection) {
          selection.insertText(emoji)
        }
      })
    })

  },
}

export default LexicalEditor
